import Reveal from '@/components/feature/Reveal';
import { categories } from '@/mocks/home';

export default function CategorySection() {
  return (
    <section id="categories" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6">
        <Reveal>
          <div className="flex flex-col gap-4 border-b border-background-300/70 pb-6 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="font-label text-xs tracking-[0.28em] text-primary-600">
                DIRECTORY
              </span>
              <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
                黑料导航分类总览
              </h2>
            </div>
            <p className="max-w-md text-sm leading-7 text-foreground-600">
              每一个分类都是一条独立的内容线，收录数量会随更新变化，点击即可跳到对应的浏览方向。
            </p>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 gap-3 sm:grid-cols-2 md:mt-10 lg:grid-cols-4 md:gap-4">
          {categories.map((cat, index) => (
            <Reveal key={cat.id} delay={(index % 4) * 60}>
              <a
                href="#feed"
                className="group flex h-full cursor-pointer flex-col rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-300 md:p-5"
              >
                <div className="flex items-start justify-between">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${cat.icon} text-xl`} />
                  </span>
                  <span className="font-display text-sm font-black text-foreground-400">
                    {String(cat.count).padStart(3, '0')}
                  </span>
                </div>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">
                  {cat.name}
                </h3>
                <p className="mt-2 flex-1 text-xs leading-6 text-foreground-600">{cat.desc}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {cat.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full border border-secondary-200 bg-secondary-50 px-2 py-0.5 font-label text-[11px] text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}